<button *ngIf="!progress" type="button" class="btn btn-primary btn-block api-btn" [disabled]="disabled"
  [style]="buttonStyle">
  {{ text }}
</button>

<button *ngIf="progress" type="button" disabled class="btn btn-primary btn-block api-btn" style="cursor: default;">
  <span *ngIf="showSpinner" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  {{ text }}
</button>
